import jwt_decode from 'jwt-decode';

import { IAccessTokenDecoded } from '@/store/models/auth.model';

export function decode_token(accessToken: string | undefined) {
  return accessToken ? jwt_decode<IAccessTokenDecoded>(accessToken) : undefined;
}
